import { connect } from 'react-redux'
import { getNotification } from '../../common/notifications/NotificationSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import Notifications, { INotificationsProps } from './Notifications'

const mapStateToProps = (state: IGlobalState): INotificationsProps => ({
  notification: getNotification(state),
})

export default connect(mapStateToProps)(Notifications)
